import { useEffect, useState } from 'react';
import useFiltersState from '../../../../state/useFiltersState';
import ModuleFilters, { TgetFiltersList } from '../../../../components/ModuleFilters/ModuleFilters';
import { getOrderFilters } from '../../../../services/orders';
import './NewOrdersFilters.scss';

const NewOrdersFilters = () => {
  const { secondOrdersFilters, setSecondOrdersFilters } = useFiltersState();
  const [countriesOptions, setCountriesOptions] = useState<string[]>([]);
  const [openMonthFilter, setOpenMonthFilter] = useState<boolean>(false);
  const [openShipmentCountryFilter, setOpenShipmentCountryFilter] = useState<boolean>(false);

  const ordersFilterMapping = {
    Mes: 'month',
    'País de envio': 'countryDestination'
  };

  const monthFilterRawOptions = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  const monthToNumberMap: Map<string, string> = monthFilterRawOptions
    ? new Map(monthFilterRawOptions?.map((month, i) => [month, i + 1]))
    : new Map();

  const getOrdersFiltersList: TgetFiltersList = (formModuleFilters, handleClickFilterOption, getFilterActiveStatus) => [
    {
      title: 'Mes',
      openFunction: setOpenMonthFilter,
      openStatus: openMonthFilter,
      rawSelectOptions: formModuleFilters('Mes', monthFilterRawOptions, monthToNumberMap),
      handleChangeSelectedOption: handleClickFilterOption('month', 'value'),
      isFilterActive: getFilterActiveStatus('month')
    },
    {
      title: 'País de envio',
      openFunction: setOpenShipmentCountryFilter,
      openStatus: openShipmentCountryFilter,
      rawSelectOptions: formModuleFilters('País de envio', countriesOptions),
      handleChangeSelectedOption: handleClickFilterOption('countryDestination', 'name'),
      isFilterActive: getFilterActiveStatus('countryDestination')
    }
  ];

  const getShipmentCountryFilterOptions = async () => {
    const response = await getOrderFilters();
    if (response?.countries) setCountriesOptions(response.countries);
  };

  useEffect(() => {
    getShipmentCountryFilterOptions();
  }, []);

  return (
    <div className="newOrdersFilters">
      <ModuleFilters
        moduleFilters={secondOrdersFilters}
        setModuleFilters={setSecondOrdersFilters}
        getFiltersList={getOrdersFiltersList}
        moduleFiltersTitlesMapping={ordersFilterMapping}
        customGap={48}
      />
    </div>
  );
};

export default NewOrdersFilters;
